import { FormattedMessage } from 'react-intl';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { paths } from '@/lib/paths';
import { commonMessages } from '@/messages/common';
import { INTL_PREFIX } from '@/messages/const';

export const intlPrefix = INTL_PREFIX.CHECKOUT;

const ConditionsOfSale = (
  <FormattedMessage
    defaultMessage='Conditions of Sale'
    id={`${intlPrefix}.conditionsOfSale`}
  />
);

export const ConditionsOfSaleAcknowledge = (isEcsOrder = false) => (
  <FormattedMessage
    defaultMessage='I have read and I accept the Breitling {conditionOfSaleLink}'
    id='placeholder.paymentMethod.consentCheckbox'
    values={{
      conditionOfSaleLink: (
        <LinkWithLocale
          href={
            isEcsOrder
              ? paths.service.termsAndConditions.url()
              : paths.termsAndCondition.url()
          }
          target='_blank'
        >
          {ConditionsOfSale}
        </LinkWithLocale>
      ),
    }}
  />
);

/**
 * The consent description for eCS service order
 */
export const ConditionsAcceptation = (
  <FormattedMessage
    defaultMessage='By accepting this estimate, you agree that work may begin immediately, thereby explicitly waiving any right of withdrawal'
    id='placeholder.paymentMethod.consentSentence'
  />
);
export const PrivacyPolicyTerms = (
  action: string,
  locale: string,
  extra = '',
) => (
  <FormattedMessage
    defaultMessage='Furthermore, by clicking on the “{action}” button{extra}, you confirm you have read the {policyLink} and have read and accepted {termsOfUseLink}.'
    id='placeholder.paymentMethod.consentDescription'
    values={{
      termsOfUseLink: (
        <LinkWithLocale href={paths.termsOfUse.url()} target='_blank'>
          <FormattedMessage {...commonMessages.breitlingTermsOfUse} />
        </LinkWithLocale>
      ),
      policyLink: (
        <LinkWithLocale href={paths.privacyPolicy.url()} target='_blank'>
          <FormattedMessage {...commonMessages.breitlingPrivacyPolicy} />
        </LinkWithLocale>
      ),
      action: action.toLocaleUpperCase(locale),
      extra: extra ? ' ' + extra : extra,
    }}
  />
);
